import React from 'react';

import { SubscriptionPlan } from '@/components/SubscriptionCard/SubscriptionCard.utils';

export const SubscriptionCardHeader = ({
  plan,
  isMostPopular,
  iconSrc,
  accentColor,
  isCurrentPlan,
}: {
  plan: SubscriptionPlan;
  isMostPopular?: boolean;
  iconSrc: string;
  accentColor?: string;
  isCurrentPlan?: boolean;
}) => {
  return (
    <div className={`flex relative justify-between p-8 rounded-t-lg`}>
      {isMostPopular && <BadgeMostPopular accentColor={accentColor!} />}

      <div className='inline-flex flex-col gap-2 py-2 text-white'>
        <span className='font-light leading-lead12 text-16px font-sans'>
          {isCurrentPlan && 'ACTIVE'} PLAN
        </span>
        <span className='font-medium leading-lead12 text-20px font-sans'>
          {plan.toUpperCase()}
        </span>
      </div>

      <div
        className='flex items-end justify-center bg-translucent p-5 rounded-2xl'
        style={{ width: 57, height: 52 }}
      >
        <img
          src={iconSrc}
          alt=''
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
          }}
        />
      </div>
    </div>
  );
};

const BadgeMostPopular = ({ accentColor }: { accentColor: string }) => {
  return (
    <div
      className={`${accentColor} absolute -top-7 left-8 rounded-lg z-10`}
      style={{ padding: 2 }}
    >
      <div className={'bg-white pb-1 pt-2 px-6'} style={{ borderRadius: 4 }}>
        <span
          className={`inline-flex items-start gap-2.5 ${accentColor} bg-clip-text text-transparent font-bold text-14px leading-9`}
        >
          <img src='/icons/trophy-solid.svg' alt='' width={20} height={18} />
          <span>MOST POPULAR</span>
        </span>
      </div>
    </div>
  );
};
